import { useEffect } from 'react'
import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { AutoPaySetupStatus, PaymentPageType } from '../../../../types/mf-execution.types'
import { useAutoPayStatusQuery } from '../../../../hooks/mf-execution/useAutoPayStatusQuery'
import { useNavigate } from 'react-router-dom'

/**
 * Net-banking Autopay setup waiting screen (v1 + v2 NET_BANKING).
 * Polls mandate status and redirects the user via the `link` field from the API.
 * UPI Autopay (`UPI_AUTOPAY`) uses `AutoPayUpiLinkWaitingPage` instead.
 */
export const AutoPayLinkWaitingPage = () => {
  const { autoPayStatus, isError, isExpired } = useAutoPayStatusQuery()
  const navigate = useNavigate()

  useEffect(() => {
    if (
      isError ||
      isExpired ||
      autoPayStatus?.status === AutoPaySetupStatus.FAILED ||
      (autoPayStatus?.status === AutoPaySetupStatus.SUCCESS &&
        (!autoPayStatus?.link || !autoPayStatus?.sxpId || !autoPayStatus?.mandateId))
    ) {
      setTimeout(() => {
        navigate(`/${PaymentPageType.SIP}/payment-failed`)
      }, 2000)
    } else if (autoPayStatus?.link) {
      setTimeout(() => {
        // create an anchor tag and set the href to the link
        const anchor = document.createElement('a')
        anchor.href = autoPayStatus?.link ?? ''
        anchor.rel = 'noopener noreferrer'
        anchor.click()
      }, 2000)
    }
  }, [autoPayStatus, isError])

  return (
    <div className='w-full h-screen relative overflow-hidden'>
      <div className='w-full h-screen flex flex-col items-center justify-center gap-5 bg-white py-8 px-5 '>
        <div className='flex justify-center items-center w-full'>
          <RenderHTML innerHTMLText={LoaderIcon} />
        </div>
        <div className='text-[#232323] text-[16px] font-[500] text-center max-w-[200px]'>
          Redirecting to Autopay setup
        </div>
      </div>
    </div>
  )
}

const LoaderIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
  <circle cx="24" cy="24" r="24" fill="#1470CC"/>
  <path d="M16.4934 32.3647L32.363 15.7697M32.363 15.7697L20.9268 16.3676M32.363 15.7697L32.8268 26.1676" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
